<template lang="pug">
form( autocomplete='false')
  v-combobox(
    :label='arreglo' 
    v-model='descripcion'
    :items='registro'
    @keyup.enter='crear({arreglo, descripcion})'
  )
    template( v-slot:selection="{ item }")
      span {{ item.descripcion }} 
       
    template( v-slot:item="{ item }"  @click.stop )
      minicrud_elemento( :elemento='item' :requiere_codigo='requiere_codigo' :arreglo='arreglo' )
      
</template>
<script>
import {mapState, mapActions} from 'vuex'
export default {
  data: ()=>({
    descripcion: ''
  }),
  props: {
    arreglo: String,
    requiere_codigo: Boolean,
    itemValue: String
  },
  methods: {
    ...mapActions({
      crear: 'Arreglos/crear',
    }),
    

  },
  computed:{
    ...mapState({
      Rules: state => state.Helpers.rules,
    }),
    registro() {
      return this.$store.getters['Arreglos/registro'](this.arreglo)
    }
  },
 
   watch:{
    'descripcion':{
      handler: function (after, before) {
        if (!this.descripcion) return
        if(this.itemValue){
          this.$emit('resultado', this.descripcion[this.itemValue])
        } else {
          this.$emit('resultado', this.descripcion)
        }
      },
      deep: true
    }
  },
  components: {
    minicrud_elemento: ()=>import('./componentes/minicrud_elemento')
  }
}
</script>